import { createAction } from 'redux-actions'
// @ts-ignore
import { googleIdentify } from './googleAnalytics'

export const sendError = createAction('ANALYTICS/SEND_ERROR')

export const track = createAction('ANALYTICS/TRACK', (category: any, action: any, data: any) => ({
  category,
  action,
  data,
}))

export const register = createAction('ANALYTICS/REGISTER', (id: any, first_login: any) => {
  googleIdentify(id)
  return { id, first_login }
})

export const showError = createAction('ANALYTICS/SHOW_ERROR')
